import { render, staticRenderFns } from "./ServicoEditarModal.vue?vue&type=template&id=b151c67c&scoped=true"
import script from "./ServicoEditarModal.vue?vue&type=script&lang=js"
export * from "./ServicoEditarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b151c67c",
  null
  
)

export default component.exports